import React from "react";
import { Avatar, Box, Grid, Icon, styled, Typography } from "@mui/material";
import dayjs from "dayjs";
import Utils from "../../../../utils";
import ChartAreaCustom from "../../shared/dashboard/ChartArea";
import CardData from "../../shared/dashboard/CardData";
import CardDashboard from "../../shared/dashboard/CardDashboard";
import { useSelector } from "react-redux";
import TableCustom from "../../shared/tableCustom";
import EmployeeInOut from "./employeeInOut";
import { useTranslation } from "react-i18next";
import OT36Dialog from "./OT36Dialog";

const StyledRoot = styled(Box)({
  "& .top-employee": {
    padding: "8px",
    // paddingTop: "16px",
    display: "flex",
    alignItems: "center",
    border: "1px solid #ececec",
    borderRadius: "4px",
  },
});

const OverviewPanel = (props) => {
  const { month, year, realEmployee, realCost, realOT, realWorkingTime, workdayRows, top5LeaveAbsent, resignList, newEmployees, fetchOT36, activeEmpMap, empLoading, costLoading, headcountTrend } = props;
  const resignCount = resignList ? resignList.length : null;
  const { t, i18n } = useTranslation();
  const top5AbsentReal = top5LeaveAbsent || null;

  const { result: dashboardOverview } = useSelector(
    (state) => state.dashboardOverview
  );


  const num = (v) => (v ? Utils.numberWithCommasWithoutDot(v) : "0");
  const workdayColumns = [
    {
      name: `${t("FullName")}`,
      minWidth: "180px",
      width: "180px",
      cellRender: (row) => (
        <Box display="flex" alignItems="center">
          <Avatar sx={{ marginRight: "8px", width: 36, height: 36 }} src={row.imageProfile} />
          <Typography>
            {row.firstname} {row.lastname}
          </Typography>
        </Box>
      ),
    },
    { name: "วันทำงาน", headerTextAlign: "center", minWidth: "80px",
      cellRender: (row) => <Box sx={{ textAlign: "center" }}>{num(row.arrive)}</Box> },
    { name: t("Absent"), headerTextAlign: "center", minWidth: "80px",
      cellRender: (row) => <Box sx={{ textAlign: "center", color: row.absent ? "#e53935" : undefined }}>{num(row.absent)} วัน</Box> },
    { name: t("Late") || "มาสาย", headerTextAlign: "center", minWidth: "80px",
      cellRender: (row) => <Box sx={{ textAlign: "center" }}>{num(row.late)} ครั้ง</Box> },
    { name: "ออกก่อน", headerTextAlign: "center", minWidth: "80px",
      cellRender: (row) => <Box sx={{ textAlign: "center" }}>{num(row.earlyBack)} ครั้ง</Box> },
    { name: "ลา", headerTextAlign: "center", minWidth: "80px",
      cellRender: (row) => <Box sx={{ textAlign: "center" }}>{num(row.leave)} วัน</Box> },
  ];
  return (
    <StyledRoot>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={12}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <CardData
                    title={t("Employees")}
                    loading={empLoading && !realEmployee}
                    dataValue={Utils.numberWithCommasWithoutDot(
                      realEmployee ? realEmployee.employeeTotal : dashboardOverview.employeeTotal
                    )}
                    dataUnit={t("Person")}
                    dynamicFontSize
                    titleIcon={
                      <Icon
                        baseClassName="fal"
                        className="fa-users"
                        color="primary"
                        style={{ display: "inline-table" }}
                      />
                    }
                  />
                </Grid>
                <Grid item xs={6}>
                  <CardData
                    title={t("SalaryTotal")}
                    loading={empLoading && !realEmployee}
                    dataValue={dashboardOverview.salaryTotal === null ? "***" : Utils.numberWithCommas(
                      realEmployee ? realEmployee.salaryTotal : (realCost ? realCost.totalSalary : dashboardOverview.salaryTotal)
                    )}
                    dataUnit={t("Baht")}
                    dynamicFontSize
                    titleIcon={
                      <Icon
                        className="fal fa-sack-dollar"
                        color="warning"
                        style={{ display: "inline-table", color: "#ffcd38" }}
                      />
                    }
                  />
                </Grid>
                <Grid item xs={6}>
                  <CardData
                    title={t("OTOver36")}
                    dataValue={dashboardOverview.employeeOTOver36Total.weekInMonth.map(
                      (week) => ({
                        name: `${dayjs(week.weekStartDateText).format(
                          "dd D MMM"
                        )} - ${dayjs(week.weekEndDateText).format("dd D MMM")}`,
                        value: week.over36HoursEmployee
                          ? week.over36HoursEmployee.filter((e) => !activeEmpMap || activeEmpMap.has(Number(e.idEmp))).length
                          : week.over36HoursEmployeeTotal,
                      })
                    )}
                    dataUnit={t("Person")}
                    dynamicFontSize
                    select
                    titleIcon={
                      fetchOT36 ? (
                        <OT36Dialog fetchOT36={fetchOT36} month={month} year={year} />
                      ) : (
                        <Icon
                          className="far fa-alarm-exclamation"
                          color="error"
                          style={{ display: "inline-table" }}
                        />
                      )
                    }
                  />
                </Grid>
                <Grid item xs={6}>
                  <CardData
                    title={t("OTTotal")}
                    loading={costLoading && realOT == null}
                    dataValue={dashboardOverview.salaryTotal === null ? "***" : (realOT == null ? "0" : Utils.numberWithCommas(realOT))}
                    dataUnit={t("Baht")}
                    dynamicFontSize
                    titleIcon={
                      <Icon
                        className="fal fa-hand-holding-usd"
                        color="warning"
                        style={{ display: "inline-table", color: "#ffcd38" }}
                      />
                    }
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* <Grid item xs={12} lg={6}>
              <CardDashboard>
                <Typography marginBottom="16px">
                  {`${t("SalaryTotal")} (${t("Yearly")} ${year})`}
                </Typography>
                <ChartAreaCustom
                  series={[
                    {
                      name: `${t("Expense")}`,
                      data: dashboardOverview.salaryTotalAllYear.map((s) => {
                        return {
                          x: dayjs()
                            .month(s.month - 1)
                            .format("MMM"),
                          y: s.salaryTotal,
                        };
                      }),
                    },
                  ]}
                />
              </CardDashboard>
            </Grid> */}
          </Grid>
        </Grid>

        {/* กราฟแนวโน้มจำนวนพนักงานรายเดือน (คำนวณจาก roster — ใช้ได้ทุกโหมดรวม "ทั้งหมด") */}
        {Array.isArray(headcountTrend) && headcountTrend.some((s) => s.y > 0) && (
          <Grid item xs={12}>
            <CardDashboard>
              <Typography marginBottom="16px">แนวโน้มจำนวนพนักงาน (รายเดือน {year})</Typography>
              <ChartAreaCustom
                series={[{ name: t("Employees"), data: headcountTrend }]}
              />
            </CardDashboard>
          </Grid>
        )}

        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={8}>
              <CardDashboard>
                <Typography marginBottom="16px">
                  สรุปขาด/สาย/ลา รายคน{" "}
                  {dayjs()
                    .month(month - 1)
                    .format("MMMM")}
                </Typography>
                {workdayRows ? (
                  <TableCustom
                    columns={workdayColumns}
                    rows={workdayRows}
                    rowsPerPageProp={5}
                    rowsPerPageOptions={[5]}
                  />
                ) : (
                  <Typography textAlign="center" color="text.third" padding="40px">
                    {t("LoadingData")}...
                  </Typography>
                )}
              </CardDashboard>
            </Grid>
            <Grid item xs={12} lg={4}>
              <CardDashboard>
                <Typography marginBottom="16px">
                  {`${t("Top5LeaveAbsent")} ${t("Month")}`}
                  {dayjs()
                    .month(month - 1)
                    .format("MMMM")}
                </Typography>
                {(top5AbsentReal || [])
                  .length > 0 && (
                  <Box
                    style={{
                      display: "flex",
                      gap: "16px",
                      flexDirection: "column",
                    }}
                  >
                    {(top5AbsentReal || []).map(
                      (e, index) => (
                        <Box key={index} className="top-employee">
                          <Icon
                            className={`fa-solid fa-square-${index + 1}`}
                            color="primary"
                            style={{
                              display: "inline-table",
                              color: index <= 2 ? "#ffcd38" : undefined,
                            }}
                          />
                          <Box
                            style={{
                              flexGrow: "1",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Avatar
                              src={e.imageProfile}
                              style={{
                                marginRight: "8px",
                                width: "32px",
                                height: "32px",
                              }}
                            />
                            <Typography>
                              {e.firstname} {e.lastname}
                            </Typography>
                          </Box>
                          <Typography>
                            {e.absentTotal} {t("Days")}
                          </Typography>
                        </Box>
                      )
                    )}
                  </Box>
                )}
                {(top5AbsentReal || [])
                  .length <= 0 && (
                  <Typography textAlign="center" color="text.third">
                    {t("NoAbsentWork")}
                  </Typography>
                )}
              </CardDashboard>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={6} lg={3}>
              <CardData
                title={t("EmployeeIn")}
                dataValue={String(
                  realEmployee ? realEmployee.employeeInTotal : dashboardOverview.employeeInfo.employeeInTotal
                )}
                dataUnit={t("Person")}
                dynamicFontSize
                titleIcon={
                  <Icon
                    className="fas fa-transporter"
                    color="success"
                    style={{ display: "inline-table" }}
                  />
                }
              />
            </Grid>
            <Grid item xs={6} lg={3}>
              <CardData
                title={t("EmployeeOut")}
                dataValue={String(
                  resignCount != null ? resignCount : dashboardOverview.employeeInfo.employeeOutTotal
                )}
                dataUnit={t("Person")}
                dynamicFontSize
                titleIcon={
                  <Icon
                    className="fas fa-person-circle-xmark"
                    color="error"
                    style={{ display: "inline-table" }}
                  />
                }
              />
            </Grid>
            <Grid item xs={6} lg={3}>
              <CardData
                title={t("TurnoverRate")}
                dataValue={(() => {
                  const out = resignCount != null ? resignCount : dashboardOverview.employeeInfo.employeeOutTotal;
                  const total = realEmployee ? realEmployee.employeeTotal : dashboardOverview.employeeTotal;
                  return total > 0 ? ((out / total) * 100).toFixed(2) : "0";
                })()}
                dataUnit="%"
                dynamicFontSize
                titleIcon={
                  <Icon
                    className="fas fa-chart-line"
                    color="primary"
                    style={{ display: "inline-table" }}
                  />
                }
              />
            </Grid>
            <Grid item xs={6} lg={3}>
              <CardData
                title={t("TurnoverYear")}
                dataValue={Number(dashboardOverview.turnoverYear || 0).toFixed(2)}
                dataUnit="%"
                dynamicFontSize
                titleIcon={
                  <Icon
                    className="fas fa-calendar-days"
                    color="primary"
                    style={{ display: "inline-table" }}
                  />
                }
              />
            </Grid>
            <Grid item xs={6} lg={3}>
              <CardData
                title={t("Male")}
                dataValue={String(realEmployee ? realEmployee.maleTotal : dashboardOverview.employeeInfo.maleTotal)}
                dataUnit={t("Person")}
                dynamicFontSize
                titleIcon={
                  <Icon
                    className="fas fa-mars"
                    color="warning"
                    style={{ display: "inline-table", color: "#35baf6" }}
                  />
                }
              />
            </Grid>
            <Grid item xs={6} lg={3}>
              <CardData
                title={t("Female")}
                dataValue={String(realEmployee ? realEmployee.femaleTotal : dashboardOverview.employeeInfo.femaleTotal)}
                dataUnit={t("Person")}
                dynamicFontSize
                titleIcon={
                  <Icon
                    className="fas fa-venus"
                    color="warning"
                    style={{ display: "inline-table", color: "#ed4b82" }}
                  />
                }
              />
            </Grid>
            <Grid item xs={6} lg={3}>
              <CardData
                title={t("AverageAge")}
                dataValue={String(dashboardOverview.employeeInfo.averageAge)}
                dataUnit={t("Year")}
                titleIcon={
                  <Icon
                    className="fas fa-people-group"
                    color="primary"
                    style={{ display: "inline-table" }}
                  />
                }
              />
            </Grid>
            <Grid item xs={6} lg={3}>
              <CardData
                title={t("WorkExperienceAvg")}
                dataValue={String(
                  dashboardOverview.employeeInfo.averageWorkExperience
                )}
                dataUnit={t("Year")}
                titleIcon={
                  <Icon
                    className="fas fa-briefcase"
                    color="primary"
                    style={{ display: "inline-table" }}
                  />
                }
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <CardDashboard>
            <Typography marginBottom="16px">
              {`${t("NewEmployeeList")} - ${t("EmployeeOut")} ${t("Month")}`}
              {dayjs()
                .month(month - 1)
                .format("MMMM")}
            </Typography>
            <EmployeeInOut employeeIn={newEmployees} employeeOut={resignList} />
          </CardDashboard>
        </Grid>
      </Grid>
    </StyledRoot>
  );
};

export default OverviewPanel;
